// extracted by mini-css-extract-plugin
module.exports = {"collapsable":"styles_collapsable__3UiI7","collapsable__title":"styles_collapsable__title__cff_P","collapsable__body":"styles_collapsable__body__9qT32"};